const listaDeRegionais = (state) => {
    return state.items;
}

const loadingRegionais = (state) => {
    return state.carregando
}

export {
    listaDeRegionais,
    loadingRegionais
}